import { TextsValidationError } from 'app/area/company-reports-administration/form/types';
import { TextValue } from 'app/area/company-reports-administration/form/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ValidationLevel } from 'ui';

export const mapTextsErrors = (
  textSet: number,
  textId: number,
  textDescription: string,
  texts: TextValue[],
  errorMessage: string) => {
  const textsErrors = texts?.flatMap<TextsValidationError>(item => {
    const itemErrors = [
      !!item.textSet && !!item.textId && !isDefinedIncludingZero(item.textDescription) && {
        id: item.id,
        field: 'textDescription',
        error: {
          level: ValidationLevel.error,
          messages: [
            {
              level: ValidationLevel.error,
              message: errorMessage
            }]
        }
      }].filter(error => error);

    return itemErrors.length > 0 ? itemErrors : undefined;
  }).filter(item => item);

  return {
    ...(!!textSet && !!textId && !isDefinedIncludingZero(textDescription) && {
      textDescription: {
        level: ValidationLevel.error,
        messages: [{ level: ValidationLevel.error, message: errorMessage }]
      }
    }),
    ...(textsErrors?.length > 0 && {
      text: textsErrors.map(error => ({
        ...error.error,
        messages: error.error.messages
          .map(message => ({
            ...message,
            parameters: {
              id: error.id,
              field: error.field
            }
          }))
      }))
    })
  };
};
